export default {
  items: [
    {
      name: 'Menu Principal',
      icon: 'icon-speedometer',
      children: [

      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_navBasico.js